:host {
  /* Substract gaps divided by tiles */
  --cms-flex-width: 0 0 calc((100% / 2) - var(--cms-spacing-050));
  width: 100%;
  background-color: transparent;
  padding: var(--cms-spacing-200) var(--cms-spacing-100);
  @include cms-components-host-defaults;
  box-sizing: border-box;
}

.host-inner {
  max-width: var(--cms-container-max-width);
  margin: 0 auto;
  display: flex;
  gap: var(--cms-spacing-100);
  text-align: center;
  justify-content: center;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
}

.icons-teaser {
  flex: var(--cms-flex-width);
  background-color: var(--cms-theme-icon-teaser-card-background-color);
  display: flex;
  cursor: pointer;

  &:hover {
    --cms-link-decoration: underline;
  }


  &.no-link {
    cursor: initial;

    &:hover {
      --cms-link-decoration: none;
      --cms-link-decoration-hover: none;
    }
  }
}

:host(.highlight) .icons-teaser {
  background-color: var(--cms-theme-icon-teaser-card-background-color-highlight);
}

.image-wrapper {
  display: block;
  line-height: 0;
}

.icon-image {
  width: auto;
}

.teaser-link {
  text-decoration: none;
  color: var(--cms-semanticColors-base-strong-text);
  padding: var(--cms-spacing-100) var(--cms-spacing-050);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: var(--cms-spacing-100);
}

.text-container {
  margin: 0 auto;
}

@include media-width($breakpoint-xs) {
  .icons-teaser {
    --cms-flex-width: 0 0 calc((100% / 3) - calc(var(--cms-spacing-100) * 2 / 3));
  }
}

@include media-width($breakpoint-sm) {
  .icons-teaser {
    --cms-flex-width: 0 0 calc((100% / 4) - var(--cms-spacing-100) * 3 / 4);
  }
}

@include media-width($breakpoint-md) {
  .icons-teaser {
    --cms-flex-width: 0 0 calc((100% / 6) - calc(var(--cms-spacing-100) * 5 / 6));
  }
}